import {
  CONSULTAMEDTURNOS_SUCCESS,
  CONSULTAMEDTURNOS_LOADING,
  CONSULTAMEDTURNOS_ERROR,
  CONSULTAMEDTURNOS_LOGOUT,
} from "../../ActionTypes";

import axiosInstance from "../../../../global/helpers/axiosInstance";
import axiosLogin from "global/helpers/axiosLogin";

// export const wsGetVerificaConsultaMedica =
//   (especialidad, medico, idPacFamiliar, osAlternativa ) => (dispatch) => {
//     dispatch({
//       type: CONSULTAMEDTURNOS_LOADING,
//     });

//    axiosInstance().then(respuesta => {
//     respuesta
//     .get(`/consulta_medica/verificar_os/${especialidad}/${medico}/${!idPacFamiliar ? '': idPacFamiliar}/${!osAlternativa ? '': osAlternativa}`)
//     .then((res) => {
//       dispatch({
//         type: CONSULTAMEDTURNOS_SUCCESS,
//         payload: res.data,
//       });
//     })
//     .catch((err) => {
//       let error = {
//         detail: err.response
//           ? err.response.data
//           : "Error al contactar el server.",
//       };

//       dispatch({
//         type: CONSULTAMEDTURNOS_ERROR,
//         payload: error,
//       });
//     });
//    } )
//   };

export const wsGetVerificaConsultaMedica =
  (especialidad, medico, idPacFamiliar, osAlternativa, nextStep) =>
  (dispatch) => {
    dispatch({ type: CONSULTAMEDTURNOS_LOADING });
    axiosLogin().then((respuesta) => {
      respuesta
        .get(
          `his/turnos/verificarOs/${especialidad}/${medico}/${
            idPacFamiliar ? idPacFamiliar : -1
          }/${osAlternativa ? osAlternativa : false}`
        )
        .then((resp) => {
          dispatch({
            type: CONSULTAMEDTURNOS_SUCCESS,
            payload: resp.data,
          });
          if (nextStep) nextStep(true, resp.data);
        })
        .catch((err) => {
          let error = {
            detail: err.response
              ? // Si err.response.data es un objeto con 'detail', extraerlo
                typeof err.response.data === "object" &&
                err.response.data.detail
                ? err.response.data.detail
                : // Si es un objeto con 'title', usar title también
                typeof err.response.data === "object" && err.response.data.title
                ? err.response.data.title
                : // Si es un objeto con 'mensaje', usar mensaje
                typeof err.response.data === "object" &&
                  err.response.data.mensaje
                ? err.response.data.mensaje
                : // Si es un string, usarlo directamente
                typeof err.response.data === "string"
                ? err.response.data
                : "Error al contactar el server."
              : "Error al contactar el server.",
          };
          dispatch({ type: CONSULTAMEDTURNOS_ERROR, payload: error });
          if (nextStep) nextStep(false, error);
        });
    });
  };

// export const wsPostConsultaMedTurnos =
//   (especialidad, agenda, fecha, particular, vc, idPacFamiliar, osAlternativa) =>
//   (dispatch) => {
//     dispatch({
//       type: CONSULTAMEDTURNOS_LOADING,
//     });

//     axiosInstance().then((respuesta) => {
//       respuesta
//         .get(
//           `/consulta_medica/turnosDisponibles/${especialidad}/${agenda}/${fecha}/${particular}/${vc}/${
//             !idPacFamiliar ? "" : idPacFamiliar
//           }/${!osAlternativa ? "" : osAlternativa}`
//         )
//         .then((res) => {
//           dispatch({
//             type: CONSULTAMEDTURNOS_SUCCESS,
//             payload: res.data,
//           });
//         })
//         .catch((err) => {
//           let error = {
//             detail: err.response
//               ? err.response.data
//               : "Error al contactar el server.",
//           };

//           dispatch({
//             type: CONSULTAMEDTURNOS_ERROR,
//             payload: error,
//           });
//         });
//     });
//   };

export const wsPostConsultaMedTurnos =
  (
    especialidad,
    agenda,
    fecha,
    particular,
    vc,
    idPacFamiliar,
    osAlternativa,
    nextStep
  ) =>
  (dispatch) => {
    dispatch({ type: CONSULTAMEDTURNOS_LOADING });
    axiosLogin().then((respuesta) => {
      respuesta
        .get(
          `his/turnos/consulta_medica/turnosDisponibles/${especialidad}/${agenda}/${fecha}/${particular}/${vc}/${
            idPacFamiliar ? idPacFamiliar : -1
          }/${!osAlternativa ? "" : osAlternativa}`
        )
        .then((resp) => {
          dispatch({
            type: CONSULTAMEDTURNOS_SUCCESS,
            payload: resp.data,
          });
          if (nextStep) nextStep(true, resp.data);
        })
        .catch((err) => {
          let error = {
            detail: err.response
              ? typeof err.response.data === "object" && err.response.data.detail
                ? err.response.data.detail
                : typeof err.response.data === "object" && err.response.data.title
                ? err.response.data.title
                : typeof err.response.data === "object" && err.response.data.mensaje
                ? err.response.data.mensaje
                : typeof err.response.data === "string"
                ? err.response.data
                : "Error al contactar el server."
              : "Error al contactar el server.",
          };
          dispatch({ type: CONSULTAMEDTURNOS_ERROR, payload: error });
          if (nextStep) nextStep(false, error);
        });
    });
  };
/* export const wsPostConsultaMedTurnos =
  (
    especialidad,
    agenda,
    fecha,
    particular,
    vc,
    idPacFamiliar,
    osAlternativa,
    nextStep
  ) =>
  (dispatch) => {
    dispatch({ type: CONSULTAMEDTURNOS_LOADING });
    axiosInstance().then((respuesta) => {
      respuesta
        .get(
          `/consulta_medica/turnosDisponibles/${especialidad}/${agenda}/${fecha}/${particular}/${vc}/${
            !idPacFamiliar ? "" : idPacFamiliar 
          }/${!osAlternativa ? "" : osAlternativa}`
        )
        .then((resp) => {
          dispatch({
            type: CONSULTAMEDTURNOS_SUCCESS,
            payload: resp.data,
          });
          if (nextStep) nextStep(true, resp.data);
        })
        .catch((err) => {
          dispatch({ type: CONSULTAMEDTURNOS_ERROR, payload: err.data });
          if (nextStep) nextStep(false, err.response.data);
        });
    });
  }; */

export const wsPostTomarTurnoConsultaMed =
  (requestBody, idPariente, nextStep) => (dispatch) => {
    dispatch({
      type: CONSULTAMEDTURNOS_LOADING,
    });

    axiosLogin().then((respuesta) => {
      respuesta
        .post(
          `his/turnos/consulta_medica/turno/${idPariente ? idPariente : -1}`,
          requestBody
        )
        .then((res) => {
          dispatch({
            type: CONSULTAMEDTURNOS_SUCCESS,
            payload: res.data,
          });
          if (nextStep) nextStep(true, res.data);
        })
        .catch((err) => {
          let error = {
            detail: err.response
              ? // Si err.response.data es un objeto con 'detail', extraerlo
                typeof err.response.data === "object" &&
                err.response.data.detail
                ? err.response.data.detail
                : // Si es un objeto con 'title', usar title también
                typeof err.response.data === "object" && err.response.data.title
                ? err.response.data.title
                : // Si es un objeto con 'mensaje', usar mensaje
                typeof err.response.data === "object" &&
                  err.response.data.mensaje
                ? err.response.data.mensaje
                : // Si es un string, usarlo directamente
                typeof err.response.data === "string"
                ? err.response.data
                : "Error al contactar el server."
              : "Error al contactar el server.",
          };

          dispatch({
            type: CONSULTAMEDTURNOS_ERROR,
            payload: error,
          });
          if (nextStep) nextStep(false, error);
        });
    });
  };
/* export const wsPostTomarTurnoConsultaMed =
  (requestBody, idPariente) => (dispatch) => {
    dispatch({
      type: CONSULTAMEDTURNOS_LOADING,
    });

    axiosInstance().then((respuesta) => {
      respuesta
        .post(
          `/consulta_medica/turno/${!idPariente ? "" : idPariente}`,
          requestBody
        )
        .then((res) => {
          dispatch({
            type: CONSULTAMEDTURNOS_SUCCESS,
            payload: res.data,
          });
        })
        .catch((err) => {
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
          };

          dispatch({
            type: CONSULTAMEDTURNOS_ERROR,
            payload: error,
          });
        });
    });
  }; */

export const logoutConsultaMedTurnos = () => (dispatch) => {
  dispatch({ type: CONSULTAMEDTURNOS_LOGOUT });
};
